import { render, staticRenderFns } from "./cat-status-flag.vue?vue&type=template&id=2011dc34&"
import script from "./cat-status-flag.vue?vue&type=script&lang=js&"
export * from "./cat-status-flag.vue?vue&type=script&lang=js&"
import style0 from "./cat-status-flag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports